import React, { useContext, useEffect, useState } from 'react';
import { ListGroup, Button } from 'react-bootstrap';
import { Link, useHistory } from 'react-router-dom';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { decode as base64_decode } from 'base-64';


import NavGroup from './NavGroup';
import { ConfigContext } from '../../../../contexts/ConfigContext';
import * as actionType from '../../../../store/actions';
import Swal from 'sweetalert2';
import moment from 'moment';

const NavContent = ({ navigation }) => {
  const history = useHistory();
  const [scrollWidth, setScrollWidth] = useState(0);
  const [prevDisable, setPrevDisable] = useState(true);
  const [nextDisable, setNextDisable] = useState(false);
  const users = JSON.parse(base64_decode(sessionStorage.getItem(`ddesp`)));
  const configContext = useContext(ConfigContext);
  const { dispatch } = configContext;

  const { layout, rtlLayout, hideButtonText } = configContext.state;

  const scrollPrevHandler = () => {
    const wrapperWidth = document.getElementById('sidenav-wrapper').clientWidth;

    let scrollWidthPrev = scrollWidth - wrapperWidth;
    if (scrollWidthPrev < 0) {
      setScrollWidth(0);
      setPrevDisable(true);
      setNextDisable(false);
    } else {
      setScrollWidth(scrollWidthPrev);
      setPrevDisable(false);
    }
  };

  const scrollNextHandler = () => {
    const wrapperWidth = document.getElementById('sidenav-wrapper').clientWidth;
    const contentWidth = document.getElementById('sidenav-horizontal').clientWidth;

    let scrollWidthNext = scrollWidth + (wrapperWidth - 80);
    if (scrollWidthNext > contentWidth - wrapperWidth) {
      scrollWidthNext = contentWidth - wrapperWidth + 80;

      setScrollWidth(scrollWidthNext);
      setPrevDisable(false);
      setNextDisable(true);
    } else {
      setScrollWidth(scrollWidthNext);
      setPrevDisable(false);
    }
  };

  const [permiteResgatarXml, setPermiteResgatarXml] = useState(false);

  let resgatarXml = false;
  

  const navItems = navigation.map((item, index) => {
    if (item.id === '40') {
      if (item.children) {
        const findEspionar = item.children.find((item) => item.id === '39');
        const index = item.children.indexOf(findEspionar);
        if (index > -1) {
          resgatarXml = true;
        }
      }
      return false;

    }

    switch (item.type) {
      case 'group':
        return (
          <NavGroup
            layout={layout}
            key={'nav-group-' + item.id}
            group={item}
          />
        );
      default:
        return false;
    }
  });

  let scrollStyle = {
    marginLeft: '-' + scrollWidth + 'px',
  };

  if (layout === 'horizontal' && rtlLayout) {
    scrollStyle = {
      marginRight: '-' + scrollWidth + 'px',
    };
  }

  useEffect(() => {
    const storage_ = sessionStorage.getItem(`ddesp`);
    const usersRt = JSON.parse(base64_decode(sessionStorage.getItem(`ddesp`)));

    const users = usersRt;

    resgatarXml = false;
    for (let i = 0; i < navigation.length; i++) {
      if (navigation[i].id === '40') {
        if (navigation[i].children) {
          const findResgatar = navigation[i].children.find((item) => item.id === '39');
          const index = navigation[i].children.indexOf(findResgatar);
          if (index > -1) {
            resgatarXml = true;
            break;
          }
        }
      }
    }
    setPermiteResgatarXml(resgatarXml);
    

  }, [navigation]);
  

  let mainContent = '';
  if (layout === 'horizontal') {
    let prevClass = ['sidenav-horizontal-prev'];
    if (prevDisable) {
      prevClass = [...prevClass, 'disabled'];
    }
    let nextClass = ['sidenav-horizontal-next'];
    if (nextDisable) {
      nextClass = [...nextClass, 'disabled'];
    }

    mainContent = (
      <div
        className='navbar-content sidenav-horizontal'
        id='layout-sidenav'
      >
        <Link
          to='#'
          className={prevClass.join(' ')}
          onClick={scrollPrevHandler}
        >
          <span />
        </Link>
        <div
          id='sidenav-wrapper'
          className='sidenav-horizontal-wrapper'
        >
          <ListGroup
            variant='flush'
            bsPrefix=' '
            as='ul'
            id='sidenav-horizontal'
            className='nav pcoded-inner-navbar sidenav-inner pb-3 '
            onMouseLeave={() => {
              dispatch({ type: actionType.NAV_CONTENT_LEAVE });
            }}
            style={scrollStyle}
          >
            {navItems}
          </ListGroup>
        </div>
        <Link
          to='#'
          className={nextClass.join(' ')}
          onClick={scrollNextHandler}
        >
          <span />
        </Link>
      </div>
    );
  } else {
    mainContent = (
      <div className='navbar-content next-scroll'>
        <PerfectScrollbar>
          <ListGroup
            variant='flush'
            as='ul'
            bsPrefix=' '
            className='nav pcoded-inner-navbar pt-2 pb-3'
            id='nav-ps-next'
          >
            {Number(configContext.state.moduloAtual) === 1 && (
              <ListGroup.Item
                as='li'
                bsPrefix=' '
                className='nav-item text-center mb-0'
              >
                <a
                  className='nav-link  btn btn-success btn-sm pb-3 text-white '
                  id='nav-15'
                  target=''
                  href='#!'
                  onClick={
                    (e) => {
                      e.preventDefault();
                      if (permiteResgatarXml) {
                        history.push('/resgate/resgatarxml');
                      } else {
                        Swal.fire({
                          title: 'Atenção',
                          text: 'Você não tem permissão para acessar esta funcionalidade.',
                          icon: 'warning',
                          confirmButtonText: 'OK',
                        });
                      }

                  }}
                >
                  <span className='pcoded-micon'>
                    <i className='mdi mdi-file-search-outline'></i>
                  </span>
                  <span className='pcoded-mtext'>Resgatar XMLs</span>
                </a>
              </ListGroup.Item>
            )}
            {navItems}
          </ListGroup>
        </PerfectScrollbar>
      </div>
    );
  }

  return <React.Fragment>{mainContent}</React.Fragment>;
};

export default NavContent;
